import { equals, find, map, reduce, prop, propOr, propEq } from 'ramda';
import { ROLES, TEAM_ROLES } from '../../../../lib/rights';
import { isSuperAdminUserRole, RoleActionEnum, RoleValueEnum } from '../../../../components/users/utils/roles';

const createRole = ({
  teamId,
  offerId,
  roleValue,
  team,
  offer,
  isArchived = false,
  role
}, toAdd) => ({
  uuid: crypto.randomUUID(),
  teamId,
  offerId,
  roleValue,
  team,
  offer,
  isArchived,
  role,
  action: toAdd ? RoleActionEnum.ADD : null
});

export const getSuperAdminRole = (toAdd) => {
  const role = find(propEq(ROLES.superAdmin, 'value'), TEAM_ROLES);
  return createRole({
    teamId: null,
    offerId: null,
    roleValue: ROLES.superAdmin,
    team: RoleValueEnum.ALL,
    offer: RoleValueEnum.ALL,
    role: role.label
  }, toAdd);
};

export const buildRole = ({
  teamId,
  offerId,
  roleValue,
  teams,
  offers,
  name
}, toAdd) => {
  const team = find(propEq(teamId, 'id'), teams);
  const offer = find(propEq(offerId, 'id'), offers);
  const role = find(propEq(roleValue, 'value'), TEAM_ROLES);
  const isAdmin = equals(ROLES.admin, roleValue);

  return createRole({
    teamId,
    offerId,
    roleValue,
    team: prop('name', team),
    offer: isAdmin ? RoleValueEnum.ALL : name || prop('offerName', offer),
    isArchived: isAdmin ? false : propOr(false, 'isArchived', offer),
    role: prop('label', role)
  }, toAdd);
};
  
export const getUserRoles = (user, teams, offers) => {
  const roles = [];
  const isSuperAdmin = isSuperAdminUserRole(user);
  if (isSuperAdmin) {
    return [getSuperAdminRole()];
  }

  const userTeams = propOr([], 'teams', user);
  const teamRoles = reduce((acc, curr) => {
    const teamId = prop('teamId', curr);
    const teamRole = propOr([], 'roles', curr);
    const definedRoles = map(({
      role,
      offerId,
      name
    }) => buildRole({
      teamId,
      offerId,
      roleValue: role,
      teams,
      offers,
      name
    }), teamRole);
    acc.push(...definedRoles);
    return acc;
  }, [], userTeams);
  roles.push(...teamRoles);

  return roles;
};